import(/* webpackMode: "eager" */ "/vercel/path0/src/app/race/page.tsx");
